import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "../client";
import type { ActionItem, ActionItemUpdate, Risk, RiskUpdate } from "../types";

const transcriptKey = (id: string) => ["transcripts", id] as const;

export function useUpdateActionItem(transcriptId: string) {
  const qc = useQueryClient();
  return useMutation<ActionItem, Error, { itemId: string; payload: ActionItemUpdate }>({
    mutationFn: ({ itemId, payload }) =>
      apiRequest(`/api/transcripts/${transcriptId}/action-items/${itemId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: transcriptKey(transcriptId) });
      // Worklist projection depends on action-item counts too.
      qc.invalidateQueries({ queryKey: ["sites"] });
    },
  });
}

export function useUpdateRisk(transcriptId: string) {
  const qc = useQueryClient();
  return useMutation<Risk, Error, { riskId: string; payload: RiskUpdate }>({
    mutationFn: ({ riskId, payload }) =>
      apiRequest(`/api/transcripts/${transcriptId}/risks/${riskId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: transcriptKey(transcriptId) });
      qc.invalidateQueries({ queryKey: ["sites"] });
    },
  });
}
